import { CurrencySymbol } from '../../utils/currencySymbol';
const DEFAULT_CURRENCY_CODE = 'PLN';
const NON_BREAKING_SPACE = String.fromCodePoint(160);
const AMOUNT_DECIMAL_SEPARATOR = '.';
const DEFAULT_CURRENCY_SYMBOL = CurrencySymbol[DEFAULT_CURRENCY_CODE];
const DEFAULT_PHONE_NUMBER_FORMAT = '### ### ####';
export * from './keycodes';
export { NON_BREAKING_SPACE, AMOUNT_DECIMAL_SEPARATOR, DEFAULT_CURRENCY_SYMBOL, DEFAULT_PHONE_NUMBER_FORMAT };
export { Language } from './languages';